import type { DmDoctorOption } from '../../../../../services/practiceDm';
import { DmPracticeOptionRow } from './DmOptionRows';

interface DoctorPracticePickerProps {
    doctor: DmDoctorOption;
    value: number | null;
    onChange: (dmPracticeId: number) => void;
}

export function DoctorPracticePicker({ doctor, value, onChange }: DoctorPracticePickerProps) {
    return (
        <section className="flex flex-col gap-2">
            <h3 className="text-[13px] font-bold text-gray-800">Practice for {doctor.fullName}</h3>
            {doctor.practices.length === 0 ? (
                <p className="text-[13px] text-gray-500">
                    This doctor has no practice in DM, so they can't be linked. Use New doctor
                    instead.
                </p>
            ) : (
                doctor.practices.map((practice) => (
                    <DmPracticeOptionRow
                        key={practice.practiceId}
                        practice={practice}
                        selected={practice.practiceId === value}
                        onSelect={() => onChange(practice.practiceId)}
                    />
                ))
            )}
        </section>
    );
}
